import styled from 'styled-components'

export const Container = styled.section`
  height: 100vh;
  background-color: #f4f4fc;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

export const Title = styled.h2`
  color: #0c0c59;
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 3rem;

  &::before,
  &::after {
    content: '-';
    margin: 0 1rem;
    color: #0c0c59;
  }
  @media screen and (max-width: 1190px) {
    font-size: 1.5rem;
  }
  @media (max-width: 600px) {
    font-size: 1.1rem;
  }
`

export const StatsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 5rem;
  flex-wrap: wrap;
  margin-bottom: 3rem;
  @media screen and (max-width: 450px) {
    gap: 1rem;
    display: grid !important;
  }
`

export const StatItem = styled.div``

export const StatValue = styled.p`
  font-size: 6rem;
  font-weight: 800;
  color: #0c0c59;
  margin: 0;

  @media screen and (max-width: 1190px) {
    font-size: 4rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 2rem;
  }
`

export const StatLabel = styled.p`
  font-size: 1.3rem;
  color: #0c0c59;
  margin-top: 0.5rem;

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
`

export const Button = styled.button`
  background: linear-gradient(90deg, #fdd96d 0%, #f08732 100%);
  color: #000;
  font-weight: 700;
  font-size: 1.125rem;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 1.5rem;
  cursor: pointer;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`
